import { useFeatureFlag } from '@americanexpress/one-experiments';
import { getActiveLocaleSelector, getTenancySelector } from '@americanexpress/travel-selectors';
import { useSelector } from 'react-redux';
import { getPrefetchedExperimentsSelector } from '../selectors/getPrefetchedExperimentsSelector';

export const useFeatureFlagWithProperties = (oneXpFeatureFlagName) => {
  const tenancy = useSelector(getTenancySelector);
  const locale = useSelector(getActiveLocaleSelector);
  const { enabled, properties } = useFeatureFlag({ featureFlagName: oneXpFeatureFlagName });
  return enabled && properties?.[tenancy]?.toLowerCase()?.includes(locale.toLowerCase());
};

export const usePrefetchedFeatureFlagWithProperties = (oneXpFeatureFlagName, state) => {
  const locale = getActiveLocaleSelector(state);
  const tenancy = getTenancySelector(state);
  const experiments = getPrefetchedExperimentsSelector(state);
  const enabled = !!experiments?.[oneXpFeatureFlagName] || false;
  const properties = experiments?.[oneXpFeatureFlagName]?.dimensions || {};
  return enabled && properties?.[tenancy]?.toLowerCase()?.includes(locale.toLowerCase());
};
